export default __webpack_public_path__ + "static/media/P316.1.09fe9469.mp3";